import {Component, OnInit} from "@angular/core";
import {DOCUMENT_TYPES, ITEM_ID_TYPE, VALUE_TYPE} from "../../enums/enums";
import {HIT_TYPES_LIST} from "../../enums/e-hit-type";
import {CURRENCY_TYPES_LIST} from "../../enums/e-currency";
import {BusService} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";
import {IDocument} from "../../interfaces/document.definition";
import {localeUtils} from "../../helpers/locale-utils";


@Component({
  templateUrl: "./lots.premium-shop-page.component.html"
})


export class LotsPremiumShopPageComponent implements OnInit {
  UI_TEXTS = UI_TEXTS;
  pageParams = paramsHelper.page()
    .setTitle("Магазин премиум валюты - Лоты");

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.PREM_SHOP_LOTS)
    .setDefaultListLabels()
    .setItemLabelQuery(`locales.${localeUtils.getLocale()}[key=name].value.0`)
    .setSearchParams(paramsHelper.search()
      .addNumberParam("id"));

  HIT_TYPES_LIST = HIT_TYPES_LIST;
  CURRENCY_TYPES_LIST = CURRENCY_TYPES_LIST;
  ITEM_ID_TYPE = ITEM_ID_TYPE;
  VALUE_TYPE = VALUE_TYPE;

  document: IDocument;


  constructor(private busService: BusService) {
  }


  ngOnInit(): void {
    this.busService.onDocumentUpdated
      .subscribe(
        e => this.document = e.document);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/prem_shop/lots.premium-shop.page.component.ts